import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

import client from '@/apollo-client';
import Container from '@/components/Container/Container';
import Header from '@/components/Header/Header';
import SearchResults from '@/components/SearchResults/SearchResults';
import { getSearchQuery } from '@/graphql/queries';
import styles from '@/styles/Home.module.sass';

export default function Search({ pageInfo, results, term }) {
  return (
    <div className={styles.container}>
      <Head>
        <title>search for {term} | cake-mag.com</title>
      </Head>
      <Header />
      <Container>
        <section className="section">
          <SearchResults pageInfo={pageInfo} results={results} term={term} />
        </section>
      </Container>
    </div>
  );
}

Search.getInitialProps = async ({ query: { q } }) => {
  if (!q) {
    return {
      results: [],
    };
  }

  const { query, variables } = getSearchQuery({ term: q });
  const { data } = await client.query({ query, variables });

  return {
    pageInfo: data?.posts?.pageInfo,
    results: data?.posts?.edges?.map(({ node }) => node),
    term: q,
  };
};

Search.propTypes = {
  pageInfo: PropTypes.shape({
    endCursor: PropTypes.string,
    hasNextPage: PropTypes.bool,
  }),
  results: PropTypes.arrayOf(
    PropTypes.shape({
      excerpt: PropTypes.string,
      featuredImage: PropTypes.shape({
        node: PropTypes.shape({
          sourceUrl: PropTypes.string,
        }),
      }),
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      uri: PropTypes.string.isRequired,
    })
  ),
  term: PropTypes.string,
};
